import * as React from 'react';
import { type ModalProps } from '@mui/material';

import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles';
import { Button } from '@process-advisor/process-miner/components/shared/button';

import { Typography } from '@mui/material';


type Props = ModalProps & {
    onCancel: () => void,
    onSave?: () => void,
    onNo?: () => void,
    open?: boolean,
}

export const Modal: React.FC<Props> = ({onCancel,onSave,onNo,open}) => {

    const modalRef = React.useRef<HTMLDivElement>(null);

    const handleOnSave = () => {
        onSave();
        onCancel();
    };

    const handleOnNo = () => {
        onNo()
    };

    const handleOnCancel = () => {
        onCancel();
    };

    return (
        <StyledWrapper open={open} onClose={onCancel} >
            <StyledModal onClick={(e) => e.stopPropagation()} ref={modalRef} width='400px'>
                <StyledHeader>
                    <StyledTitle>AI Process Optimizer</StyledTitle>
                </StyledHeader>
                <Typography
                        variant="caption"
                        align="center"
                        sx={{ fontSize: '14px', fontFamily: 'system-ui'
}}
                        component="div">Do you want to save changes to the analysis model?
                </Typography>                
                <StyledFooter>
                     <Button label='Yes' onClick={handleOnSave} disabled={false} />
                     <Button label='No' onClick={handleOnNo} disabled={false} />
                     <Button label='Cancel' onClick={handleOnCancel} disabled={false} />
                </StyledFooter>
            </StyledModal>
        </StyledWrapper>
    );
};
